/**
 * 使用项目信息
 * @return {object}
 */
export const useAppInfo = () => {
    return window.FEGOEditor.app.project.appInfo;
};
